import { randRecentDate, randNumber, randTimeZone, randFullName } from '@ngneat/falso';

import { POD } from '../base';

export class MockPOD extends POD {
   constructor() {
      super();

      this.date = randRecentDate().toString();
      this.time = randRecentDate().toISOString().slice( 11, 19 );
      this.timezone = randTimeZone();
      this.name = randFullName();
      this.pieces = randNumber({ min: 1, max: 100 });
      this.piecesUom = 'pcs';
   }
}
